import React from 'react'
import { Dialog, DialogContent } from '@mui/material'
import GeneralConfirmMessg from './GeneralConfirmationMssgComponents/GeneralConfirmMessg'
import GeneralConfirmButtons from './GeneralConfirmationMssgComponents/GeneralConfirmButtons'

const GeneralConfirmationMssg = (props) => {
  const { isGeneralConfirmDialogOpen, isDarkModeActive } = props
  return (
    <Dialog
      disableScrollLock
      open={isGeneralConfirmDialogOpen}
      PaperProps={{
        style: {
          borderRadius: 10,
          background: isDarkModeActive ? 'rgb(49, 48, 53, 0.6)' : 'white',
          backdropFilter: 'blur(4px)',
          color: isDarkModeActive ? 'white' : 'inherit',
        },
      }}
    >
      <DialogContent>
        <div style={{ color: isDarkModeActive && 'white' }}>
          <GeneralConfirmMessg {...props} />
          <GeneralConfirmButtons {...props} />
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default GeneralConfirmationMssg
